import { usePipelineContext } from '@/context/pipelineContext';
import { getOutstandingDays } from '@/utils/constants';
import { Typography } from '@mui/material';
import React, { useMemo } from 'react';

const DataGridOutstandingDays = ({ dealStage, effectiveDate }) => {
	const { stages } = usePipelineContext();

	const currentStage = dealStage && stages?.find((s) => s.stageId === dealStage);

	const outstandingDays = useMemo(() => {
		if (!effectiveDate || currentStage?.order !== 0) return '-';
		const days = getOutstandingDays(effectiveDate);
		if (days === 1) return '1 day';
		return `${days} days`;
	}, [effectiveDate, currentStage]);

	return <Typography>{outstandingDays}</Typography>;
};
export default DataGridOutstandingDays;
